import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AnnonceService from "services/annonceService";

// Async thunks for login and logout
export const getAll = createAsyncThunk(
  "club/announcements",
  async ({ page = 1, searchValue = null }, { rejectWithValue }) => {
    try {
      const response = await AnnonceService.getAll(page, searchValue);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const getAnnounceDetails = createAsyncThunk(
  "club/announcementDetails",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AnnonceService.getAnnounceDetails(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const getAnnounceDetailsAgents = createAsyncThunk(
  "agent/announcementDetailsAgents",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AnnonceService.getAnnounceDetailsAgents(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Initial state
const initialState = {
  annonces: [],
  loading: false,
  error: null,
  totalItems: 0,
  currentPage: 1,
  totalPages: 0,
  fetchLoading: false,
  annonce: null,
};

// Slice
const annonceSlice = createSlice({
  name: "annonce",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAll.pending, (state) => {
        state.fetchLoading = true;
        state.error = null;
      })
      .addCase(getAll.fulfilled, (state, action) => {
        state.fetchLoading = false;
        state.annonces = action.payload.announcements;
        state.totalItems = action.payload.totalAnnouncements;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(getAll.rejected, (state, action) => {
        state.annonces = [];
        state.fetchLoading = false;
        state.error = action.payload;
      })
      .addCase(getAnnounceDetails.pending, (state) => {
        state.fetchLoading = true;
        state.error = null;
      })
      .addCase(getAnnounceDetails.fulfilled, (state, action) => {
        state.fetchLoading = false;
        state.annonce = action.payload;
      })
      .addCase(getAnnounceDetails.rejected, (state, action) => {
        state.annonce = null;
        state.fetchLoading = false;
        state.error = action.payload;
      })
      .addCase(getAnnounceDetailsAgents.pending, (state) => {
        state.fetchLoading = true;
        state.error = null;
      })
      .addCase(getAnnounceDetailsAgents.fulfilled, (state, action) => {
        state.fetchLoading = false;
        state.annonce = action.payload;
      })
      .addCase(getAnnounceDetailsAgents.rejected, (state, action) => {
        state.annonce = null;
        state.fetchLoading = false;
        state.error = action.payload;
      });
  },
});
export const { setCurrentPage } = annonceSlice.actions;
export default annonceSlice.reducer;
